<app-complex-modal-template
    [canConfirm]="!!fileTitle().value && !isMapImageLoading()"
    [stepNumber]="1"
    [title]="'decisionSupportMap' | transloco"
    (onClickEvent)="closeModal($event)">
    <ng-container>
        @if (!isMapImageLoading()) {
            <div class="flex flex-row">
                <div class="h-full w-full pr-4">
                    <app-input-text
                        [inputFormControl]="fileTitle()"
                        [label]="'title' | transloco"
                        [placeholder]="'fileTitle' | transloco" />
                    <div class="pl-2 pt-2">
                        <app-select
                            [canClear]="false"
                            [defaultValue]="[formatOptions[0]]"
                            [label]="'format' | transloco: { COUNT: 1 }"
                            [options]="formatOptions"
                            (optionSelected)="selectFormat($event)" />
                    </div>
                    <div class="pl-2 pt-2">
                        <app-select
                            [canClear]="false"
                            [defaultValue]="defaultPrintSizeOption"
                            [label]="'printSize' | transloco"
                            [options]="printSizeOptions"
                            (optionSelected)="selectPrintSize($event)" />
                    </div>
                    <div
                        class="flex flex-row pl-2 pt-4 cursor-pointer"
                        (click)="toggleNorthStar()">
                        <app-checkbox
                            [checkboxState]="addNorthStar() ? CheckboxState.CHECKED : CheckboxState.UNCHECKED" />
                        <span
                            class="pl-2"
                            [class]="addNorthStar() ? 'text-custom-blue' : 'text-custom-dark-grey'"
                            >{{ 'addNorthStar' | transloco }}</span
                        >
                    </div>
                    <div
                        class="flex flex-row pl-2 pt-4 cursor-pointer"
                        (click)="toggleScale()">
                        <app-checkbox [checkboxState]="addScale() ? CheckboxState.CHECKED : CheckboxState.UNCHECKED" />
                        <span
                            class="pl-2"
                            [class]="addScale() ? 'text-custom-blue' : 'text-custom-dark-grey'"
                            >{{ 'addScale' | transloco }}</span
                        >
                    </div>
                    <div
                        class="flex flex-row pl-2 pt-4 cursor-pointer"
                        (click)="toggleLegend()">
                        <app-checkbox [checkboxState]="addLegend() ? CheckboxState.CHECKED : CheckboxState.UNCHECKED" />
                        <span
                            class="pl-2"
                            [class]="addLegend() ? 'text-custom-blue' : 'text-custom-dark-grey'"
                            >{{ 'addLegend' | transloco }}</span
                        >
                    </div>
                </div>
                <div>
                    <img
                        class="h-full w-full rounded-lg object-contain"
                        [src]="mapToImageService.imgUrl()" />
                </div>
            </div>
        } @else {
            @if (selectedFormat() === MapExportFormatEnum.SVG) {
                <div class="flex pb-4">
                    <span class="text-center mx-auto">{{ 'mapExportSvg' | transloco }}</span>
                </div>
            }
            <app-loading />
        }
    </ng-container>
</app-complex-modal-template>
